import React from 'react'

export interface HrefProps {
  href: string
  className?: string
  onClick?: React.MouseEventHandler
  children: React.ReactNode
}

export const Href: React.FC<HrefProps> = ({
  href,
  className,
  onClick,
  children,
}) => {
  return (
    <a href={href} className={className} onClick={onClick}>
      {children}
    </a>
  )
}
